var chunkMapping = {
	"219": [
		427
	]
};
var idToExternalAndNameMapping = {
	"427": [
		"default",
		"./MainApp",
		997
	]
};
var idToRemoteMap = {
	"427": [
		{
			"externalType": "module",
			"name": "",
			"externalModuleId": 997
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}